
import { defineComponent, PropType } from 'vue'
import { ActivePromocodeText } from './activePromocode'

/** Активный промокод проекта в форме оплаты: на что действует, до какого числа и дал ли скидку в этом счёте. */
export default defineComponent({
    props: {
        text: { type: Object as PropType<ActivePromocodeText>, required: true },
    },
})
